var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "c-controls__group" }, [
        _c("label", { staticClass: "c-controls__label" }, [_vm._v("Team")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.team,
                expression: "team"
              }
            ],
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.team = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function($event) {
                  return _vm.chooseTeam()
                }
              ]
            }
          },
          _vm._l(_vm.teams, function(team) {
            return _c(
              "option",
              { key: team.uuid, domProps: { value: team.uuid } },
              [_vm._v("\n\t\t\t\t" + _vm._s(team.name) + "\n\t\t\t")]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.slide.settings.timer
        ? _c("TimerControl", { on: { subcommand: _vm.subcommand } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }